module.exports = __webpack_public_path__ + "img/xihu.1b822d00.png";